// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mapContainer {
  position: relative;
  width: 100%;
  height: 100%;
  height: calc(100vh - 66px); /* Adjust this value based on the height of your TitleBar */
  overflow: hidden; /* Prevent overflow */
}

/* .mapContainer .maplibregl-popup {
  max-width: 1000px;
} */

/* Base popup styling */
.custom-popup .maplibregl-popup-content {
  min-width: 200px;
  max-width: 300px;
  width: auto;
  padding: 10px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.2) !important;
  border-radius: 6px;
}

/* Optional: Style the popup tip */
.custom-popup .maplibregl-popup-tip {
  border-top-color: rgba(255, 255, 255, 0.9);
}

/* Optional: Style the popup close button */
.custom-popup .maplibregl-popup-close-button {
  font-size: 16px;
  padding: 5px;
  color: #666;
}

/* Remove any additional padding from inner container */
.custom-popup .maplibregl-popup-content > div {
  padding: 0 !important;
  max-width: 100% !important;
}

/* React popup styles */
.react-popup .maplibregl-popup-content {
  padding: 0 !important;
  margin: 0 !important;
  border-radius: 8px !important;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  max-height: 80vh !important; /* Maximum height of 80% viewport height */
  overflow: hidden !important; /* Hide overflow on parent, let child handle scrolling */
}

/* Hide the close button for React popups */
.react-popup .maplibregl-popup-close-button {
  display: none !important;
}

.react-popup .maplibregl-popup-content > div {
  margin: 0 !important;
  padding: 0 !important;
  height: auto !important; /* Allow content to determine height */
  max-height: 80vh !important; /* Maximum height of 80% viewport height */
  overflow-y: auto !important; /* Enable scrolling if content exceeds max height */
}

/* Ensure carousel is visible and properly sized */
.react-popup .maplibregl-popup-content .react-multi-carousel-list {
  overflow: visible !important;
}

.react-popup .maplibregl-popup-content .react-multi-carousel-item {
  padding-bottom: 8px !important; /* Add some space below carousel items */
}

/* Remove default popup tip styling for React popups */
.react-popup .maplibregl-popup-tip {
  border-top-color: white !important;
}

/* Traditional popup styles */
.custom-popup .maplibregl-popup-content {
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
}

`, "",{"version":3,"sources":["webpack://./src/components/map/MapComponent.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0BAA0B,EAAE,2DAA2D;EACvF,gBAAgB,EAAE,qBAAqB;AACzC;;AAEA;;GAEG;;AAEH,uBAAuB;AACvB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,iDAAiD;EACjD,kBAAkB;AACpB;;AAEA,kCAAkC;AAClC;EACE,0CAA0C;AAC5C;;AAEA,2CAA2C;AAC3C;EACE,eAAe;EACf,YAAY;EACZ,WAAW;AACb;;AAEA,uDAAuD;AACvD;EACE,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,6BAA6B;EAC7B,qDAAqD;EACrD,2BAA2B,EAAE,0CAA0C;EACvE,2BAA2B,EAAE,wDAAwD;AACvF;;AAEA,2CAA2C;AAC3C;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,uBAAuB,EAAE,sCAAsC;EAC/D,2BAA2B,EAAE,0CAA0C;EACvE,2BAA2B,EAAE,mDAAmD;AAClF;;AAEA,kDAAkD;AAClD;EACE,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B,EAAE,wCAAwC;AAC1E;;AAEA,sDAAsD;AACtD;EACE,kCAAkC;AACpC;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,yCAAyC;AAC3C","sourcesContent":[".mapContainer {\n  position: relative;\n  width: 100%;\n  height: 100%;\n  height: calc(100vh - 66px); /* Adjust this value based on the height of your TitleBar */\n  overflow: hidden; /* Prevent overflow */\n}\n\n/* .mapContainer .maplibregl-popup {\n  max-width: 1000px;\n} */\n\n/* Base popup styling */\n.custom-popup .maplibregl-popup-content {\n  min-width: 200px;\n  max-width: 300px;\n  width: auto;\n  padding: 10px;\n  box-shadow: 0 4px 12px rgba(0,0,0,0.2) !important;\n  border-radius: 6px;\n}\n\n/* Optional: Style the popup tip */\n.custom-popup .maplibregl-popup-tip {\n  border-top-color: rgba(255, 255, 255, 0.9);\n}\n\n/* Optional: Style the popup close button */\n.custom-popup .maplibregl-popup-close-button {\n  font-size: 16px;\n  padding: 5px;\n  color: #666;\n}\n\n/* Remove any additional padding from inner container */\n.custom-popup .maplibregl-popup-content > div {\n  padding: 0 !important;\n  max-width: 100% !important;\n}\n\n/* React popup styles */\n.react-popup .maplibregl-popup-content {\n  padding: 0 !important;\n  margin: 0 !important;\n  border-radius: 8px !important;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;\n  max-height: 80vh !important; /* Maximum height of 80% viewport height */\n  overflow: hidden !important; /* Hide overflow on parent, let child handle scrolling */\n}\n\n/* Hide the close button for React popups */\n.react-popup .maplibregl-popup-close-button {\n  display: none !important;\n}\n\n.react-popup .maplibregl-popup-content > div {\n  margin: 0 !important;\n  padding: 0 !important;\n  height: auto !important; /* Allow content to determine height */\n  max-height: 80vh !important; /* Maximum height of 80% viewport height */\n  overflow-y: auto !important; /* Enable scrolling if content exceeds max height */\n}\n\n/* Ensure carousel is visible and properly sized */\n.react-popup .maplibregl-popup-content .react-multi-carousel-list {\n  overflow: visible !important;\n}\n\n.react-popup .maplibregl-popup-content .react-multi-carousel-item {\n  padding-bottom: 8px !important; /* Add some space below carousel items */\n}\n\n/* Remove default popup tip styling for React popups */\n.react-popup .maplibregl-popup-tip {\n  border-top-color: white !important;\n}\n\n/* Traditional popup styles */\n.custom-popup .maplibregl-popup-content {\n  border-radius: 8px;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
